import {Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from "@angular/core";

@Component({
    selector: 'overlay',
    templateUrl: './overlay.component.html',
    providers: []
})
export class OverlayComponent implements OnChanges {
    @Input() name: string;

    @Input() show: boolean;

    @Output() onSubmit: EventEmitter<boolean> = new EventEmitter();

    @Output() onCancel: EventEmitter<boolean> = new EventEmitter();

    @ViewChild('submitButton') submitButton: ElementRef;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.show && !changes.show.firstChange &&
            changes.show.previousValue === false &&
            changes.show.currentValue === true) {
            setTimeout(() => {
                if (this.submitButton) {
                    this.submitButton.nativeElement.focus();
                }
            });
        }
    }

    submit(): void {
        this.onSubmit.emit(true);
    }

    cancel(): void {
        this.onCancel.emit(true);
    }
}
